import type { CardFormField } from "./form_fields";

// Contains all card types and which form fields should be shown for each type.
export const CardTypes = {
	action: {
		label: "card.type.action",
		fields: [
			"CardPitch",
			"CardName",
			"CardResource",
			"CardText",
			"CardPower",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardSubType",
			"CardRarity",
			"CardDefense",
			"CardLife",
		],
	},
	attack_reaction: {
		label: "card.type.attack_reaction",
		fields: [
			"CardPitch",
			"CardName",
			"CardResource",
			"CardText",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardSubType",
			"CardRarity",
			"CardDefense",
		],
	},
	block: {
		label: "card.type.block",
		fields: [
			"CardPitch",
			"CardName",
			"CardText",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardSubType",
			"CardRarity",
			"CardDefense",
		],
	},
	defense_reaction: {
		label: "card.type.defense_reaction",
		fields: [
			"CardPitch",
			"CardName",
			"CardResource",
			"CardText",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardSubType",
			"CardRarity",
			"CardDefense",
		],
	},
	demi_hero: {
		label: "card.type.demi_hero",
		fields: [
			"CardName",
			"CardText",
			"CardHeroIntellect",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardSubType",
			"CardLife",
			"CardRarity",
		],
	},
	equipment: {
		label: "card.type.equipment",
		fields: [
			"CardName",
			"CardText",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardSubType",
			"CardRarity",
			"CardDefense",
		],
	},
	hero: {
		label: "card.type.hero",
		fields: [
			"CardName",
			"CardText",
			"CardHeroIntellect",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardSubType",
			"CardLife",
			"CardRarity",
		],
	},
	instant: {
		label: "card.type.instant",
		fields: [
			"CardPitch",
			"CardName",
			"CardResource",
			"CardText",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardSubType",
			"CardRarity",
			"CardDefense",
		],
	},
	macro: {
		label: "card.type.macro",
		fields: [
			"CardName",
			"CardText",
			"CardRarity",
			"CardSubType",
			"CardMacroGroup",
		],
	},
	mentor: {
		label: "card.type.mentor",
		fields: [
			"CardName",
			"CardText",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardRarity",
			"CardDefense",
			"CardSubType",
		],
	},
	resource: {
		label: "card.type.resource",
		fields: [
			"CardPitch",
			"CardName",
			"CardText",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardSubType",
			"CardRarity",
		],
	},
	token: {
		label: "card.type.token",
		fields: [
			"CardName",
			"CardText",
			"CardPower",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardLife",
			"CardSubType",
			"CardRarity",
		],
	},
	weapon: {
		label: "card.type.weapon",
		fields: [
			"CardName",
			"CardText",
			"CardPower",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardWeapon",
			"CardRarity",
			"CardSubType",
		],
	},
	weapon_equipment: {
		label: "card.type.weapon_equipment",
		fields: [
			"CardName",
			"CardText",
			"CardPower",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardSubType",
			"CardWeapon",
			"CardDefense",
			"CardRarity",
		],
	},
	ally: {
		label: "card.type.ally",
		fields: [
			"CardName",
			"CardText",
			"CardPower",
			"CardTalent",
			"CardClass",
			"CardSecondaryClass",
			"CardLife",
			"CardRarity",
			"CardSubType",
		],
	},
	event: {
		label: "card.type.event",
		fields: [
			"CardName",
			"CardText",
			"CardPower",
			"CardClass",
			"CardSecondaryClass",
			"CardRarity",
			"CardSubType",
		],
	},
	meld: {
		label: "card.type.meld",
		// Only the shared stats are shown in the main form.
		// Per-half fields (name, text, class, subtype, talent, artwork) are
		// handled separately by MeldHalfFields and stored in meldHalfA / meldHalfB.
		fields: [
			"CardPitch",
			"CardResource",
			"CardPower",
			"CardDefense",
			"CardLife",
			"CardHeroIntellect",
			"CardRarity",
		],
	},
} satisfies Record<string, { label: string; fields: readonly CardFormField[] }>;

// Utility type for string representation of each card type.
export type CardType = keyof typeof CardTypes;
